import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { noteService } from "../../services/note.service";

export const queryNoteBySessionId = createAsyncThunk(
  "noteManage/queryNoteBySessionId",
  async ({ sessionId, filter }, { rejectWithValue }) => {
    try {
      const response = await noteService.queryNoteBySessionId(
        sessionId,
        filter
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listNoteByMessageId = createAsyncThunk(
  "noteManage/listNoteByMessageId",
  async (messageId, { rejectWithValue }) => {
    try {
      const response = await noteService.listNoteByMessageId(messageId);

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addNote = createAsyncThunk(
  "noteManage/addNote",
  async (data, { rejectWithValue }) => {
    try {
      const response = await noteService.addNote(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editNote = createAsyncThunk(
  "noteManage/editNote",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await noteService.editNote(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeNote = createAsyncThunk(
  "noteManage/removeNote",
  async (id, { rejectWithValue }) => {
    try {
      const response = await noteService.removeNote(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
